export default "__VITE_ASSET__BQiPIBtN__"